import { type QueriesObject, type QueryResults, type System } from '../../odie';
import type { GameScene } from '../GameScene';
import { BlockComponent } from '../components/BlockComponent';
import { BlockEntity } from '../entities/BlockEntity';
import { blockIsBasic } from '../util/blockTools';
import { isPowerBlock } from '../util/matchTools';

export class RescueLevelSystem implements System {
  public static readonly NAME = 'rescueLevel';
  public static Queries: QueriesObject = {
    block: {
      components: [BlockComponent],
      removed: true,
    },
  };
  public scene!: GameScene;
  public queries!: QueryResults;
  public onObstacleCleared?: (entity: BlockEntity) => void;

  public removedFromQuery(entity: BlockEntity) {
    const blockId = entity.c.block.blockId;

    // Ignore basic blocks
    if (blockIsBasic(blockId)) return;

    // Ignore power blocks
    if (isPowerBlock(entity)) return;

    // Notify obstacle removal
    this.onObstacleCleared?.(entity);
  }
}
